export enum SseMessageType {
  Open = 'open',
  Error = 'error',
  Message = 'message',
  ProcessMetadata = 'processMetadata',
  ProcessState = 'processState',
  Data = 'data',
  RunAction = 'runAction',
  Heartbeat = 'heartbeat',
  GeneralData = 'generalData',
  TokenState = 'tokenState',
  NewProcessStarted = 'newProcessStarted',
  AgentResponse = 'agentResponse',
  ChatHistory = 'chatHistory',
  WorkflowSuccess = 'workflowSuccess',
  WorkflowError = 'workflowError',
  ChatError = 'chatError',
  UploadSuccess = 'uploadSuccess',
  UploadError = 'uploadError',
  HandleIntent = 'handleIntent',
  ReloadProcess = 'reloadProcess',
  Notification = 'notification',
  NotificationRead = 'notificationRead',
}

export enum SseEventType {
  PROCESS = 'process-instance',
  TASK_MANAGER = 'view',
  GENERIC = 'generic',
}

export enum SseType {
  CHAT_WORKFLOW_RESPONSE = 'CHAT_WORKFLOW_RESPONSE',
  UI_FLOW_WORKFLOW_RESPONSE = 'UI_FLOW_WORKFLOW_RESPONSE',
  UI_FLOW_FILE_UPLOAD = 'UI_FLOW_FILE_UPLOAD',
  UI_FLOW_FILE_UPLOAD_MULTIPLE = 'UI_FLOW_FILE_UPLOAD_MULTIPLE',
  CHAT_FILE_UPLOAD = 'CHAT_FILE_UPLOAD',
  CHAT_FILE_UPLOAD_MULTIPLE = 'CHAT_FILE_UPLOAD_MULTIPLE',
}

export type EventData = Record<string, any>

export enum WorkflowResultFlag {
  RESULT = 'RESULT',
  HTTP_QUERY = 'HTTP_QUERY',
}

/**
 * Envelope sent on a workflowSuccess SSE event. When outputDelivery is RESULT
 * the output is inline in `data`; when HTTP_QUERY it must be fetched from the
 * workflow output endpoint (which returns the output data directly, not this
 * envelope).
 */
export interface WorkflowSuccessEnvelope {
  outputDelivery: WorkflowResultFlag
  data?: EventData
  metadata?: Record<string, any>
}

export interface SseConnectionLike {
  onopen: (() => void) | null
  onerror: ((error: Event) => void) | null
  addEventListener(type: string, listener: (event: MessageEvent<string>) => void): void
  close(): void
}

export type SseEventSourceFactory = (
  url: string,
  headers: Record<string, string>
) => SseConnectionLike

export type SseConnection = SseConnectionLike
